/* @flow */

import * as React from "react";

const AdvancedTableContext = React.createContext<any>({});

export default AdvancedTableContext;
